import React from "react";
import { Box, Typography } from "@mui/material";

const IntroLoader = ({
  message = "Loading your HOA portal...",
  gifSrc = "/myhoa_loading_animation.gif",
  maxWidth = 390,
}) => {
  return (
    <Box
      sx={{
        minHeight: "100dvh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        py: 2,
        background:
          "linear-gradient(180deg, #f8fafc 0%, #eef3f8 50%, #f8fafc 100%)",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth,
          backgroundColor: "rgba(255,255,255,0.94)",
          borderRadius: "24px",
          boxShadow: "0 18px 50px rgba(0,0,0,0.10)",
          border: "1px solid rgba(20,40,80,0.06)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 3, sm: 4 },
          py: { xs: 5, sm: 6 },
          backdropFilter: "blur(10px)",
        }}
      >
        <Box
          component="img"
          src={gifSrc}
          alt="Loading"
          sx={{
            width: { xs: "150px", sm: "200px" },
            maxWidth: "100%",
            height: "auto",
            objectFit: "contain",
            mb: 2.5,
          }}
        />

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          {[0, 1, 2, 3].map((dot) => (
            <Box
              key={dot}
              sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor: "#2f63ad",
                animation: "dotBounce 0.9s infinite ease-in-out",
                animationDelay: `${dot * 0.15}s`,
                "@keyframes dotBounce": {
                  "0%, 80%, 100%": {
                    transform: "scale(0.7)",
                    opacity: 0.45,
                  },
                  "40%": {
                    transform: "scale(1.15)",
                    opacity: 1,
                  },
                },
              }}
            />
          ))}
        </Box>

        <Typography
          sx={{
            mt: 2,
            fontSize: "0.95rem",
            color: "#607086",
            fontWeight: 500,
            textAlign: "center",
          }}
        >
          {message}
        </Typography>
      </Box>
    </Box>
  );
};

export default IntroLoader;